import Login from "../components/login-form/Login";
import ChangePassword from "../components/login-form/ChangePassword";
import ForgotPassword from "../components/login-form/ForgotPasswordForm";
// import PartnerDetails from "../components/partner-details/partner-details";
import PartnerOrganisation from "../components/partner-organization";
// import Help from "../components/login-form/Help";
import FeedBack from "../components/login-form/Feedback";
import EditSponsors from "../components/partner-organization/edit-logos";
import EditVideos from "../components/partner-organization/edit-videos";
import FullMember from "../components/partner-organization/full-member";
import HubMember from "../components/partner-organization/hub-member";
import PendingApprovalTable from "../components/table/pendingApprovalTable";
import HubPendingApprovalTable from "../components/table/hubPendingApprovalTable";
import MicrositePendingApprovalTable from "../components/table/micrositePendingApprovalTable";
import OrgDetailsPage from "../components/table/orgDetailsPage";
import Sponsors from "../components/partner-organization/sponsors-table";
import FullDeleteReviews from "../components/partner-organization/deleteReviews/full-delete-reviews";
import HubDeleteReviews from "../components/partner-organization/deleteReviews/hub-delete-reviews";
import ResetPasswordForm from "../components/login-form/ResetPassword";
import PartnerDetailsV2 from "../components/partner-details/PartnerDetailsV2";
import Onboarding from "../components/login-form/Onboarding/Onboarding";
import PaymentHistory from "../components/login-form/PaymentHistory/PaymentHistory";

const protectedRoutes = [
  {
    path: "partner-details",
    component: <PartnerDetailsV2 />,
    exact: true,
  },
  {
    path: "partner-org",
    component: <PartnerOrganisation />,
    exact: true,
  },
  {
    path: "onboarding",
    component: <Onboarding />,
    exact: true,
  },
  {
    path: "payment-history",
    component: <PaymentHistory />,
    exact: true,
  },
  {
    path: "change-password",
    component: <ChangePassword />,
    exact: true,
  },
  // {
  //   path: "help",
  //   component: <Help />,
  //   exact: true,
  // },
  {
    path: "feedback",
    component: <FeedBack />,
    exact: true,
  },
  {
    path: "add-sponsors",
    component: <EditSponsors />,
    exact: true,
  },
  {
    path: "edit-sponsors",
    component: <EditSponsors />,
    exact: true,
  },
  {
    path: "carousel",
    component: <EditVideos />,
    exact: true,
  },
  {
    path: "full-members",
    component: <FullMember />,
    exact: true,
  },
  {
    path: "hub-members",
    component: <HubMember />,
    exact: true,
  },
  {
    path: "full-pending",
    component: <PendingApprovalTable />,
    exact: true,
  },
  {
    path: "hub-pending",
    component: <HubPendingApprovalTable />,
    exact: true,
  },
  {
    path: "microsite-pending",
    component: <MicrositePendingApprovalTable />,
    exact: true,
  },
  {
    path: "full-delete-reviews",
    component: <FullDeleteReviews />,
    exact: true,
  },
  {
    path: "hub-delete-reviews",
    component: <HubDeleteReviews />,
    exact: true,
  },
  {
    path: "org-details",
    component: <OrgDetailsPage />,
    exact: true,
  },
  {
    path: "sponsors",
    component: <Sponsors />,
    exact: true,
  },
];

const publicRoutes = [
  {
    path: "PartnerAdmin",
    component: <Login />,
    exact: true,
  },
  {
    path: "forgot-password",
    component: <ForgotPassword />,
    exact: true,
  },
  {
    path: "reset-password/:token",
    component: <ResetPasswordForm />,
    exact: true,
  }
];

export { protectedRoutes, publicRoutes };
